import React, { Component } from "react";
import Header from "../../shared-components/Header/Header";
import "./Home.scss";
import { HashLink, NavHashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import Logo from "../../assets/images/whiteLogo.svg";
import whoWeAre from "../../assets/images/Who-We-Are.png";
import pragatiKendraExhibition from "../../assets/images/pragatiKendraExhibition.png";
import Publications from "../../assets/images/publications.png";
import PublicationsMob from "../../assets/images/publicationsMobile.png";
import calenderIcon from "../../assets/images/calenderIcon.svg";
import bookIcon from "../../assets/images/bookIcon.svg";
import OwlCarousel from "react-owl-carousel2";
import $ from "jquery";

import archiveThumbAUGY26 from "../../assets/images/archives/DOM-AUG2026.png";
import archiveThumbJULY26 from "../../assets/images/archives/DOM-JULY2026.png";
import archiveThumbJUNE26 from "../../assets/images/archives/DOM-JUNE2026.png";
import archiveThumbMAY26 from "../../assets/images/archives/DOM-MAY2026.png";
import archiveThumbAPR26 from "../../assets/images/archives/DOM-APR2026.png";
import archiveThumbMAR26 from "../../assets/images/archives/mar2026Dom-th.jpg";
import archiveThumbFEB26 from "../../assets/images/archives/feb2026Dom-th.jpg";
import archiveThumbJAN26 from "../../assets/images/archives/domJan2026-Th.jpg";
import archiveThumbDEC25 from "../../assets/images/archives/DOM-DEC2025.png";
import archiveThumbNOV25 from "../../assets/images/archives/DOM-NOV2025.png";
import WOW from "wowjs";
import scrollArrow from "../../assets/images/scrollDown.svg";

import latestTalksbanner2 from "../../assets/images/latest-talk/Businessinthetime.png";
import latestTalksbanner3 from "../../assets/images/latest-talk/Power_Privilege.png";
import latestTalksbanner4 from "../../assets/images/latest-talk/TimberTradeTrajectory.png";
import latestTalksbanner5 from "../../assets/images/latest-talk/BlueJeansTransformation.png";
import latestTalksbanner6 from "../../assets/images/latest-talk/MadMenOfBombay.png";
import latestTalksbanner7 from "../../assets/images/latest-talk/TheGlobalMerchants.png";
import latestTalksbanner8 from "../../assets/images/latest-talk/Typewriter.png";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import closeIcon from "../../assets/images/closeIcon.svg";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import resetIcon from "../../assets/images/resetIcon.svg";

import Footer from "../../shared-components/Footer/Footer";
import { Accordion, Tabs, Tab, Form, FloatingLabel } from "react-bootstrap";
import FeedbackForm from "../whatWedo/Talks/FeedbackForm";

import Carousel from 'react-bootstrap/Carousel';
import banner1 from "../../assets/images/bannerBg.png";
import banner2 from "../../assets/images/book/fromTheFrugalToTheOrnateBanner.png";
import banner2Tab from "../../assets/images/book/fromTheFrugalToTheOrnateTabBanner.png";
import banner2Mobi from "../../assets/images/book/fromTheFrugalToTheOrnateMobiBanner.png";
// import banner3 from "../../assets/images/19thAnnualLecture.png";
// import banner3Tab from "../../assets/images/19thAnnualLectureTab.png";
// import banner3Mobi from "../../assets/images/19thAnnualLectureMobile.png";



export class Home extends Component {
  constructor(){
    super();   
      this.handleChildUnmount = this.handleChildUnmount.bind(this);
  }
    state = {
      open: false,
      openFeedback:false,
      feedbackOpen: false,
      formFeedback:''
    };
  openDialog() {
    this.setState({ open: true });
   // this.setState({ type });
  }
  closeDialog() {
    this.setState({ open: false });
  }


   // FeedbackFormRef = ({handleOpen}) => {
  //   debugger;
  //   //const {val}=handleOpen || {};
  //   //if(handleOpen!=null || handleOpen!=undefined)
  //   this.openDialogBox = handleOpen;
  // }
  
  onOpenDialogClick = (e) => {
    //  this.openDialogBox(e);
    const formName = e
      this.setState({
        formFeedback:formName
      })
    this.setState({ openFeedback: true})
    }
  
    handleChildUnmount(){
      this.setState({openFeedback: false});
      this.setState({formFeedback:''});
  }

// openDialog(type) {
//   this.setState({ open: true });
//   this.setState({ type });
// }

  // Defining WOW
  componentDidMount() {
    new WOW.WOW({
      live: false,
    }).init();
  }

  render() {
    const options = {
      items: 1,
      nav: true,
      autoplay: false,
      loop: false,
      rewindNav: false,
      stagePadding: 50,
      navText: [
        "<div class='nav-btn prev-slide'></div>",
        "<div class='nav-btn next-slide'></div>",
      ],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          nav: true,
          stagePadding: 0,
        },
        600: {
          items: 1,
          nav: false,
          stagePadding: 0,
        },
        1000: {
          items: 1,
          nav: true,
          loop: false,
          stagePadding: 50,
        },
      },
    };
    const optionsTwo = {
      items: 2,
      nav: true,
      autoplay: false,
      loop: false,
      rewindNav: false,
      stagePadding: 50,

      navText: [
        "<div class='nav-btn prev-slide image-shadow'></div>",
        "<div class='nav-btn next-slide image-shadow'></div>",
      ],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          nav: true,
          stagePadding: 0,
        },
        600: {
          items: 1,
          nav: false,
          stagePadding: 0,
        },
        1000: {
          items: 2,
          nav: true,
          loop: false,
          stagePadding: 50,
        },
      },
    };

    const events = {
      onDragged: function (event) {},
      onChanged: function (event) {},
      };

      
    return (
      <div className="homePage">
        <Header className="header2" />
            <section id="section-one" className="virtalTour verticalMiddle sectionOne">
                <Carousel>

                    {/* <Carousel.Item><a href="https://docs.google.com/forms/d/e/1FAIpQLSdArLMvlDLqvqAnl_0dFWvxV2vofV-4uKL8T2IC19DeQvZa_A/viewform" target="_blank" rel="noopener noreferrer">
                        <img
                            className="d-xl-block d-lg-block d-md-none d-none img-fluid"
                            src={banner3}
                            alt="First slide"
                        /> </a>

                       <a href="https://docs.google.com/forms/d/e/1FAIpQLSdArLMvlDLqvqAnl_0dFWvxV2vofV-4uKL8T2IC19DeQvZa_A/viewform" target="_blank" rel="noopener noreferrer"><img
                            className="d-xl-none d-lg-block d-md-block d-none img-fluid"
                            src={banner3Tab}
                            alt="First slide"
                        /></a>

                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSdArLMvlDLqvqAnl_0dFWvxV2vofV-4uKL8T2IC19DeQvZa_A/viewform" target="_blank" rel="noopener noreferrer"><img
                            className="d-xl-none d-lg-none d-md-none d-sm-block d-xs-block img-fluid"
                            src={banner3Mobi}
                            alt="First slide"
                        /></a>


                        
                    </Carousel.Item> */}
                    
                    <Carousel.Item>
                        <img
                            className="d-xl-block d-lg-block d-md-none d-none img-fluid"
                            src={banner2}
                            alt="Second slide"
                        /> 

                        <img
                            className="d-xl-none d-lg-block d-md-block d-none img-fluid"
                            src={banner2Tab}
                            alt="Second slide"
                        />

                        <img
                            className="d-xl-none d-lg-none d-md-none d-sm-block d-xs-block img-fluid"
                            src={banner2Mobi}
                            alt="Second slide"
                        />


                        <Carousel.Caption>
                        <div className="container">
                            <div className="bannerInfo banner2Txt">
                                <h1>OUT NOW</h1>

                                <h2>FROM THE FRUGAL<br />TO THE ORNATE</h2>
                                <p>
                                    STORIES OF THE SEAT IN INDIA
                                </p>

                                <h4><i>By SARITA SUNDAR</i></h4>

                                

                                <a
                                        href="https://www.amazon.in/Frugal-Ornate-Stories-Seat-India/dp/8193274016/ref=sr_1_1?crid=2X2B4D0LLSWM1&keywords=from+the+frugal+to+the+ornate+stories+of+the+seat+in+india&qid=1665389689&s=books&sprefix=from+the+frugal+to+the+ornate%2Cstripbooks%2C613&sr=1-1 "
                                    target="_blank"
                                    className="bannerBtn readMore"
                                >
                                    <span></span> BUY NOW
                                </a>
                            </div>
                            </div>
                        </Carousel.Caption>
                    </Carousel.Item>

                    <Carousel.Item>
                        <img
                            className="d-block img-fluid"
                            src={banner1}
                            alt="First slide"
                        />
                        <Carousel.Caption>
                        <div className="container">
                            <div className="bannerInfo text-center banner1Txt">
                                <h1>Virtual Tour</h1>

                                <p>
                                    A ballot box from India's first elections in 1952. Currency notes
                                    saved from the Bombay Docks explosion. A square Navtal lock.
                                    Godrej's first corporate film from 1969. Explore all this and more
                                    of 125 years of Godrej history in this virtual tour of our
                                    permanent exhibition 'Back to the Future'!
                                </p>
                                <a
                                        href="https://archives.godrejenterprises.com/virtualtour/"
                                    target="_blank"
                                    className="bannerBtn readMore"
                                >
                                    <span></span> LET'S START THE TOUR
                                </a>
                            </div>
                            </div>
                        </Carousel.Caption>
                    </Carousel.Item>
                    
                </Carousel>
          <HashLink
            className="scrollDown"
            // example of custom scroll function using the scroll prop
            scroll={(el) => el.scrollIntoView({ behavior: "smooth" })}
            to={"/home#section-two"}
          >
            <img src={scrollArrow} alt="Scroll Down"></img>
          </HashLink>
        </section>

        <section id="section-two" className="who-we-are verticalMiddle">
          <div className="container p-4 p-lg-0">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="whoWeareInfo pe-lg-5 pb-5">
                  <h2 className="secHeader mb-4">Who we are</h2>
                  <p>
                    Located in Mumbai, Godrej Archives is the Godrej group's
                    business archive. The Archives collects, preserves and
                    manages records covering 125 years of the company's history.
                    The idea was mooted in 1997, the group's centenary year, by
                    Mr. Sohrab Godrej, former chairman of the Godrej group, who
                    had over the years, taken up the task of collecting relevant
                    documents and photographs. Since then, Archives has been
                    recording the history of Godrej – its products, plants and
                    people – and making it available for research.
                  </p>
                  <Nav.Link href="/who-we-are" bsPrefix="readMore mt-3">
                    <span></span> EXPLORE
                  </Nav.Link>
                </div>
              </div>
              <div className="col-md-6">
                <figure>
                  <img
                    src={whoWeAre}
                    alt="Who We Are"
                    className="img-fluid"
                  ></img>
                </figure>
              </div>
            </div>
          </div>
        </section>
        <section id="latestTalks" className="latestTalks py-90">
          <div className="container-fluid p-4 p-lg-0">
            <h2 className="secHeader mb-4">Talks</h2>
            <p className="mb-4">
              Our talks and lectures stir discussions around business history,
              business archives, products &amp; commodities, <br></br>national
              development, global economy and more. Let's keep the conversation
              flowing!
            </p>
            <OwlCarousel ref="car" options={options} events={events}>
              <div className="item">
                <div className="row align-items-end">
                  <div className="col-md-7">
                    <figure className="m-0">
                      <img src={latestTalksbanner7} alt="slider 1"></img>
                    </figure>
                  </div>
                  <div className="col-md-4">
                    <div className="letsTalkDetails">
                      <p class="mt-4 mb-0">Annual Lecture</p>
                      <h4 className="mt-1">The Global Merchants</h4>
                      <div className="actionBtn mb-5 mb-lg-1 ">
                        <Link to="/annual-details/16" className="detailsBtn">
                          DETAILS
                        </Link>
                        <Button
                          className="ms-3 registerBtn"
                          onClick={this.onOpenDialogClick.bind(this,"THURSDAY TALK")}
                        >
                          Feedback
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="row align-items-end">
                  <div className="col-md-7">
                    <figure className="m-0">
                      <img src={latestTalksbanner6} alt="slider 1"></img>
                    </figure>
                  </div>
                  <div className="col-md-4">
                    <div className="letsTalkDetails">
                      <p class="mt-4 mb-0">Thursday Talk</p>
                      <h4 className="mt-1">
                        Mad Men of Bombay: Revisiting the Creative Revolution in
                        Indian Advertising
                      </h4>
                      <div className="actionBtn">
                        <Link to="/talk-details/1" className="detailsBtn">
                          DETAILS
                        </Link>
                        <Button
                          className="ms-3 registerBtn"
                          onClick={this.onOpenDialogClick.bind(this,"THURSDAY TALK")}
                        >
                          Feedback
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="row align-items-end">
                  <div className="col-md-7">
                    <figure className="m-0">
                      <img src={latestTalksbanner5} alt="slider 1"></img>
                    </figure>
                  </div>
                  <div className="col-md-4">
                    <div className="letsTalkDetails">
                      <p class="mt-4 mb-0">Thursday Talk</p>
                      <h4 className="mt-1">
                        The Global Blue Jeans Transformation
                      </h4>
                      <div className="actionBtn">
                        <Link to="/talk-details/2" className="detailsBtn">
                          DETAILS
                        </Link>
                        <Button
                          className="ms-3 registerBtn"
                          onClick={this.onOpenDialogClick.bind(this,"THURSDAY TALK")}
                        >
                          Feedback
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="row align-items-end">
                  <div className="col-md-7">
                    <figure className="m-0">
                      <img src={latestTalksbanner4} alt="slider 1"></img>
                    </figure>
                  </div>
                  <div className="col-md-4">
                    <div className="letsTalkDetails">
                      <p class="mt-4 mb-0">Thursday Talk</p>
                      <h4 className="mt-1">
                        Timber Trade Trajectory - Urbanization of Bombay and
                        Deforestation of Western India: Nineteenth Century
                      </h4>
                      <div className="actionBtn">
                        <Link to="/talk-details/3" className="detailsBtn">
                          DETAILS
                        </Link>
                        <Button
                          className="ms-3 registerBtn"
                          onClick={this.onOpenDialogClick.bind(this,"THURSDAY TALK")}
                        >
                          Feedback
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="row align-items-end">
                  <div className="col-md-7">
                    <figure className="m-0">
                      <img src={latestTalksbanner3} alt="slider 1"></img>
                    </figure>
                  </div>
                  <div className="col-md-4">
                    <div className="letsTalkDetails">
                      <p class="mt-4 mb-0">Thursday Talk</p>
                      <h4 className="mt-1">
                        Power, Privilege and Posture: The Politics of the Seat
                        in India
                      </h4>
                      <div className="actionBtn">
                        <Link to="/talk-details/4" className="detailsBtn">
                          DETAILS
                        </Link>
                        <Button
                          className="ms-3 registerBtn"
                          onClick={this.onOpenDialogClick.bind(this,"THURSDAY TALK")}
                        >
                          Feedback
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="row align-items-end">
                  <div className="col-md-7">
                    <figure className="m-0">
                      <img src={latestTalksbanner2} alt="slider 1"></img>
                    </figure>
                  </div>
                  <div className="col-md-4">
                    <div className="letsTalkDetails">
                      <p class="mt-4 mb-0">Thursday Talk</p>
                      <h4 className="mt-1">
                        Business in the Time of Contagion
                      </h4>
                      <div className="actionBtn">
                        <Link to="/talk-details/5" className="detailsBtn">
                          DETAILS
                        </Link>
                        <Button
                          className="ms-3 registerBtn"
                          onClick={this.onOpenDialogClick.bind(this,"THURSDAY TALK")}
                        >
                          Feedback
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="row align-items-end">
                  <div className="col-md-7">
                    <figure className="m-0">
                      <img src={latestTalksbanner8} alt="slider 1"></img>
                    </figure>
                  </div>
                  <div className="col-md-4">
                    <div className="letsTalkDetails">
                      <p class="mt-4 mb-0">Thursday Talk</p>
                      <h4 className="mt-1">Typewriter Tip Tip</h4>
                      <div className="actionBtn">
                        <Link to="/talk-details/6" className="detailsBtn">
                          DETAILS
                        </Link>
                        <Button
                          className="ms-3 registerBtn"
                          onClick={this.onOpenDialogClick.bind(this,"THURSDAY TALK")}
                        >
                          Feedback
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </OwlCarousel>
            {/* {this.state.feedbackOpen && (
              <FeedbackForm
                type={"THURSDAY TALK"}
                open={this.state.feedbackOpen}
                closeDialog={() => this.setState({ feedbackOpen: false })}
              />
            )} */}

{this.state.openFeedback ? <FeedbackForm unmountMe={this.handleChildUnmount}  openFeedback={this.state.openFeedback} formFeedback={this.state.formFeedback} ></FeedbackForm>:null}
            
            <Dialog open={this.state.open} onEnter={console.log("Hey.")}>
              <div className="header px-5 py-4">
                <div className="close" onClick={this.closeDialog.bind(this)}>
                  <img src={closeIcon} alt="Close Icon"></img>
                </div>
                <h2 className="secHeader">REGISTRATION FORM</h2>
                <p className="m-0">All fields are mandetory</p>
              </div>

              <DialogContent>
                <div className="dialogInfo ">
                  <div className="formBio p-5">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="formHeader mt-4 mb-3">
                          PERSONAL DETAILS
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="formGrid">
                          <div className="formIcon">
                            <i className="fa fa-user"></i>
                          </div>
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Name"
                            className="mb-3"
                          >
                            <Form.Control type="text" placeholder="Name" />
                          </FloatingLabel>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="formGrid">
                          <div className="formIcon">
                            <i className="fa fa-envelope"></i>
                          </div>
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Email ID"
                            className="mb-3"
                          >
                            <Form.Control type="email" placeholder="Email" />
                          </FloatingLabel>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="formGrid">
                          <div className="formIcon">
                            <i className="fa fa-envelope"></i>
                          </div>
                          <FloatingLabel
                            controlId="floatingSelectGrid"
                            label="Location (India / Other)"
                          >
                            <Form.Select aria-label="Floating label select example">
                              <option>Open this select menu</option>
                              <option value="1">One</option>
                              <option value="2">Two</option>
                              <option value="3">Three</option>
                            </Form.Select>
                          </FloatingLabel>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="formGrid">
                          <div className="formIcon">
                            <i className="fa fa-user"></i>
                          </div>
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Organization"
                            className="mb-3"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Organization"
                            />
                          </FloatingLabel>
                        </div>
                      </div>
                      <div className="text-center actionBtn mt-4">
                        <button className="resetBtn">
                          <img
                            src={resetIcon}
                            alt="Reset Icon"
                            className="me-2"
                          ></img>
                          Reset
                        </button>
                        <button className="submitBtn ms-2">SUBMIT</button>
                      </div>
                    </div>
                  </div>
                </div>
              </DialogContent>
            </Dialog>
            <Nav.Link
              href="/talks"
              bsPrefix="readMore mt-lg-4 mt-4 mb-5 mb-lg-0"
            >
              <span></span> EXPLORE
            </Nav.Link>
          </div>
        </section>
        <section id="pragatiKendraExhibition" className="exhibition verticalMiddle">
          <div className="container p-4 p-lg-0">
            <div className="row align-items-center">
                <h2 className="secHeader mb-4"> Exhibitions</h2>
            <p className="mb-4">
             Our exhibitions go beyond products! They celebrate the people, ideas and machines behind <br></br> them that contributed to building India’s economy, industry, environment and society. 
            </p>
         <div class="row  p-0 exhibitionRight">
              <div className="col-md-8 p-0">
                <figure className="mb-0">
                  <img
                    src={pragatiKendraExhibition}
                    alt="pragatiKendraExhibition"
                    className="img-fluid d-block"
                  ></img>
                </figure>
              </div>
                   <div className="col-md-4 p-0 d-flex align-items-center ">
                <div className=" pe-lg-5 p-5 ">
                  <h5><strong>Pragati Kendra: 70 Years of Progress</strong></h5>
                  <p>
                  Celebrating seven decades of empowering communities through healthcare, education, welfare initiatives, and women's advancement.
                  </p>
                  <Nav.Link
                    href="https://archives.godrejenterprises.com/Pragati-Kendra-exhibition/index.html" target="_blank"
                    bsPrefix="readMore mt-lg-4 mt-4"
                  >
                    <span></span> EXPLORE
                  </Nav.Link>
                </div>
              </div></div>
            </div>
          </div>
        </section>
        <section id="publications" className="publications verticalMiddle py-5">
          <div className="container p-4 p-lg-0">
            <h2 className="secHeader mb-4">Publications</h2>
            <div className="row">
              <div className="col-md-10 m-auto">
                <figure>
                  <img
                    src={Publications}
                    alt="Publications Banner"
                    className="img-fluid d-none d-sm-none d-lg-block"
                  ></img>
                  <img
                    src={PublicationsMob}
                    alt="Publications Banner"
                    className="img-fluid d-block d-sm-block d-lg-none"
                  ></img>
                </figure>
                <div className="publicationsBelow mt-4">
                  <div className="row ">
                    <div className="col-md-5">
                      <h4>Archives Times: Current Issue</h4>
                      <ul className="archivesCalender">
                        <li>
                          <img src={calenderIcon} alt="Calender Icon"></img>
                         May  2026                        </li>
                        <li>
                          <img src={bookIcon} alt="Book Icon"></img> Volume 5,
                          Issue 3
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-7">
                      <p>
                    When objects speak, they tell stories across space and time. 
                      </p>
                      <p>2025 saw Godrej Enterprises Archives and CEPT Ahmedabad co-host an exhibition on three Godrej icons — the Tubular Chair, Storwel, and Refrigerator. This issue of Archives Times covers its curation and design, and explores the dialogues and ideas it stirred. Plus, our staff share insights on a significant collection of industrial magazines and reflect on 19 years of archival research. </p>
                    </div>
                  </div>
                  <Nav.Link
                    href="/archive-times"
                    bsPrefix="readMore mt-lg-4 mt-4"
                  >
                    <span></span> EXPLORE
                  </Nav.Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="archiveTales" className="archiveTales pt-90 pb-90">
          <div className="archiveTalesInfo position-relative ">
            <div className="container p-4 p-lg-0">
              <div className="row">
                <div className="col-md-12 ms-auto">
                  <div className="row">
                    <div className="col-md-4">
                      <h2 className="secHeader mb-4">Archive Tales</h2>
                      <p>
                        Bringing you fascinating stories of grit and innovation,
                        of enterprise and humanity from our vast archival
                        collection that will shine a light on the illustrious
                        corporate past of the Godrej Group.
                      </p>
                    </div>
                    <div className="col-md-8 pe-0">
                      <div className="archiveTabs">
                        <Nav.Link
                          href="/archive-tales"
                          bsPrefix="readMore mt-lg-4 mt-3 text-left"
                        >
                          EXPLORE
                        </Nav.Link>
                      </div>
                      <OwlCarousel
                        ref="car"
                        options={optionsTwo}
                        events={events}
                                        >

 <div className="item">
                                                <figure>
                                                    <img
                                                        src={archiveThumbAUGY26}
                                                        alt="Channelling change"
                                                        className="img-fluid"></img>
                                                </figure>
                                                <div className="overlaySec">
                                                    <a
                                                        href="https://archives.godrejenterprises.com/DOM-Lectures/domAug2026_index.html"
                                                        target="_blank"
                                                        className="readMore"
                                                    >
                                                        Read More
                                                    </a>
                                                    <div className="itemInfo">
                                                        <div className="title">
                                                            DOCUMENT OF THE MONTH - August 2026
                                                        </div>
                                                        <p>The Politics of a Lock</p>
                                                    </div>
                                                </div>
                                            </div>


                                          <div className="item">
                                                <figure>
                                                    <img
                                                        src={archiveThumbJULY26}
                                                        alt="Channelling change"
                                                        className="img-fluid"></img>
                                                </figure>
                                                <div className="overlaySec">
                                                    <a
                                                        href="https://archives.godrejenterprises.com/DOM-Lectures/dom_July2026_index.html"
                                                        target="_blank"
                                                        className="readMore"
                                                    >
                                                        Read More
                                                    </a>
                                                    <div className="itemInfo">
                                                        <div className="title">
                                                            DOCUMENT OF THE MONTH - July 2026
                                                        </div>
                                                        <p>Reading Steel Shortage through a Glass-Top Table</p>
                                                    </div>
                                                </div>
                                            </div>
    
                                          <div className="item">
                                                <figure>
                                                    <img
                                                        src={archiveThumbJUNE26}
                                                        alt="Channelling change"
                                                        className="img-fluid"></img>
                                                </figure>
                                                <div className="overlaySec">
                                                    <a
                                                        href="https://archives.godrejenterprises.com/DOM-Lectures/dom_June2026_index.html"
                                                        target="_blank"
                                                        className="readMore"
                                                    >
                                                        Read More
                                                    </a>
                                                    <div className="itemInfo">
                                                        <div className="title">
                                                            DOCUMENT OF THE MONTH - June 2026
                                                        </div>
                                                        <p>From Mumbai to Mombasa: Godrej’s 1950s East Africa Push</p>
                                                    </div>
                                                </div>
                                            </div>


                                          
                                          <div className="item">
                                                <figure>
                                                    <img
                                                        src={archiveThumbMAY26}
                                                        alt="Channelling change"
                                                        className="img-fluid"></img>
                                                </figure>
                                                <div className="overlaySec">
                                                    <a
                                                        href="https://archives.godrejenterprises.com/DOM-Lectures/dom_May2026_index.html"
                                                        target="_blank"
                                                        className="readMore"
                                                    >
                                                        Read More
                                                    </a>
                                                    <div className="itemInfo">
                                                        <div className="title">
                                                            DOCUMENT OF THE MONTH - May 2026
                                                        </div>
                                                        <p>The Office That Ran on Order: Management Lessons from 1963</p>
                                                    </div>
                                                </div>
                                            </div>


                                          <div className="item">
                                                <figure>
                                                    <img
                                                        src={archiveThumbAPR26}
                                                        alt="Channelling change"
                                                        className="img-fluid"></img>
                                                </figure>
                                                <div className="overlaySec">
                                                    <a
                                                        href="https://archives.godrejenterprises.com/DOM-Lectures/dom_apr2026_index.html"
                                                        target="_blank"
                                                        className="readMore"
                                                    >
                                                        Read More
                                                    </a>
                                                    <div className="itemInfo">
                                                        <div className="title">
                                                            DOCUMENT OF THE MONTH - April 2026
                                                        </div>
                                                        <p>Typing a nation: the All-Indian Typewriter</p>
                                                    </div>
                                                </div>
                                            </div>

                                          <div className="item">
                                                <figure>
                                                    <img
                                                        src={archiveThumbMAR26}
                                                        alt="Channelling change"
                                                        className="img-fluid"></img>
                                                </figure>
                                                <div className="overlaySec">
                                                    <a
                                                        href="https://archives.godrejenterprises.com/DOM-Lectures/dom_mar2026_index.html"
                                                        target="_blank"
                                                        className="readMore"
                                                    >
                                                        Read More
                                                    </a>
                                                    <div className="itemInfo">
                                                        <div className="title">
                                                            DOCUMENT OF THE MONTH - March 2026
                                                        </div>
                                                        <p>A Factory and a Flower Show </p>
                                                    </div>
                                                </div>
                                            </div>

                                           <div className="item">
                                                <figure>
                                                    <img
                                                        src={archiveThumbFEB26}
                                                        alt="Channelling change"
                                                        className="img-fluid"></img>
                                                </figure>
                                                <div className="overlaySec">
                                                    <a
                                                        href="https://archives.godrejenterprises.com/DOM-Lectures/dom_feb2026_index.html"
                                                        target="_blank"
                                                        className="readMore"
                                                    >
                                                        Read More
                                                    </a>
                                                    <div className="itemInfo">
                                                        <div className="title">
                                                            DOCUMENT OF THE MONTH - February 2026
                                                        </div>
                                                        <p>A Legacy of Compassion and Collective Responsibility</p>
                                                    </div>
                                                </div>
                                            </div>

                                          <div className="item">
                                                <figure>
                                                    <img
                                                        src={archiveThumbJAN26}
                                                        alt="Channelling change"
                                                        className="img-fluid"></img>
                                                </figure>
                                                <div className="overlaySec">
                                                    <a
                                                        href="https://archives.godrejenterprises.com/DOM-Lectures/dom_Jan2026_index.html"
                                                        target="_blank"
                                                        className="readMore"
                                                    >
                                                        Read More
                                                    </a>
                                                    <div className="itemInfo">
                                                        <div className="title">
                                                            DOCUMENT OF THE MONTH - January 2026
                                                        </div>
                                                        <p>Channelling change: the world of television</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="item">
                                                <figure>
                                                    <img
                                                        src={archiveThumbDEC25}
                                                        alt="Lights Camera Chairs"
                                                        className="img-fluid"></img>
                                                </figure>
                                                <div className="overlaySec">
                                                    <a
                                                        href="https://archives.godrejenterprises.com/DOM-Lectures/dom_Dec2025_index.html"
                                                        target="_blank"
                                                        className="readMore"
                                                    >
                                                        Read More
                                                    </a>
                                                    <div className="itemInfo">
                                                        <div className="title">
                                                            DOCUMENT OF THE MONTH - December 2025
                                                        </div>
                                                        <p>Taking Flight!</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="item">
                                                <figure>
                                                    <img
                                                        src={archiveThumbNOV25}
                                                        alt="Lights Camera Chairs"
                                                        className="img-fluid"></img>
                                                </figure>
                                                <div className="overlaySec">
                                                    <a
                                                        href="https://archives.godrejenterprises.com/DOM-Lectures/dom_Nov2025_index.html"
                                                        target="_blank"
                                                        className="readMore"
                                                    >
                                                        Read More
                                                    </a>
                                                    <div className="itemInfo">
                                                        <div className="title">
                                                            DOCUMENT OF THE MONTH - November 2025
                                                        </div>
                                                        <p>Lights, Camera… Chairs!</p>
                                                    </div>
                                                </div>
                                            </div> 

                      </OwlCarousel>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}
export default Home;
